import { render, staticRenderFns } from "./GameBroadcast.vue?vue&type=template&id=3aedfd22&"
import script from "./GameBroadcast.vue?vue&type=script&lang=js&"
export * from "./GameBroadcast.vue?vue&type=script&lang=js&"
import style0 from "./GameBroadcast.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VFlex,VLayout,VProgressCircular,VSelect})


/* hot reload */
if (module.hot) {
  var api = require("/Users/finnkelly/Code/Go Remote/remote-chat-finn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3aedfd22')) {
      api.createRecord('3aedfd22', component.options)
    } else {
      api.reload('3aedfd22', component.options)
    }
    module.hot.accept("./GameBroadcast.vue?vue&type=template&id=3aedfd22&", function () {
      api.rerender('3aedfd22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/GameBroadcast.vue"
export default component.exports